import React from 'react';
import { JcErrorBoundary, JcErrorBoundaryProps } from './JcErrorBoundary';
import { useThrowReportedErrors } from '../../utils/JcAsyncError';

/**
 * Lives *inside* the boundary so the error it re-throws propagates up to be
 * caught. Renders its children untouched until then.
 */
const JcAsyncErrorThrower = (props: { children: React.ReactNode }): React.ReactElement => {
    useThrowReportedErrors();
    return <>{props.children}</>;
};

export interface JcAsyncErrorBoundaryProps extends JcErrorBoundaryProps { }

/**
 * A {@link JcErrorBoundary} that also catches async failures surfaced via
 * {@link reportAsyncError} (e.g. Firestore snapshot listener errors), not just
 * errors thrown during render. Wrap the app's content with this once.
 */
export const JcAsyncErrorBoundary = (props: JcAsyncErrorBoundaryProps): React.ReactElement => {
    const { children, ...boundaryProps } = props;
    return (
        <JcErrorBoundary {...boundaryProps}>
            <JcAsyncErrorThrower>{children}</JcAsyncErrorThrower>
        </JcErrorBoundary>
    );
};
